import axios from 'axios';
import checkout from './checkout';
import checkoutProcess from './checkoutProcess';
import checkin from './checkin';
import auditlog from './auditlog';
import addUser from './addUser';
import course from './course';
import domain from './domain';
import main from './main';
import corporation from './corporation';
import courseAttendees from './courseAttendees';
import phpAppEndpoints from './phpAppEndpoints';
import phpCourseContent from './phpCourseContent';
import orders from './orders';
import applications from './applications';
import people from './people';
import performancePlans from './performancePlans';
import accessResolution from './accessResolution';

axios.defaults.baseURL = URL_MANAGER_API;
//axios.defaults.baseURL = 'http://localhost:3000/'
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common.Accept = 'application/json';

axios.interceptors.request.use((request) => {
    request.headers.Authorization = localStorage.getItem('token');
  return request;
}, error => Promise.reject(error));
axios.interceptors.response.use(response => response, error =>
  Promise.reject(error),
);


export default {
    corporation,
    checkout,
    checkoutProcess,
    checkin,
    auditlog,
    addUser,
    orders,
    course,
    main,
    domain,
    courseAttendees,
    phpAppEndpoints,
    phpCourseContent,
    applications,
    people,
    performancePlans,
    accessResolution
};
